<div class="provider-info-cell">
    <div class="provider-avatar" [style.background]="data.avatarBg" [style.color]="data.avatarColor">
        {{ data.avatarInitial }}
    </div>
    <div class="provider-names">
        <p class="provider-name">{{ data.trade_name || data.business_name }}</p>
        <p class="provider-type">{{ data.provider_type || '—' }}</p>
    </div>
</div>
